<script>
import {BTabs, BTab, BCard, BFormGroup, BFormTextarea} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {required} from '@validations'
import {Button} from "@core/components/common";
import {i18nApi, ProductApi} from "@core/api";
import backendResponse from "@core/mixins/ui/backend-response";
import Overlay from "@core/components/common/Overlay.vue";

export default {
    mixins: [backendResponse],
    components: {
        Overlay,
        Button, BTabs, BTab, BCard, ValidationProvider, ValidationObserver, BFormGroup, BFormTextarea,
    },
    props: {
        id: {
            default: null
        }
    },
    data() {
        return {
            languages: [],
            statement: {},
            required,
            showLoading: true
        }
    },
    methods: {
        save() {
            this.showLoading = true;
            this.$refs.statement.validate().then(isValid => {
                if (!isValid) {
                    this.showLoading = false;
                    return;
                }
                if (this.id) {
                    ProductApi
                        .updateGeneralProductStatement(this.id, this.statement)
                        .then(() => {
                            this.showDefaultSuccessMessage('Statement has been updated', true);
                        })
                        .catch(this.handleBackendError)
                        .finally(() => this.showLoading = false)
                    ;
                } else {
                    ProductApi
                        .createGeneralProductStatement(this.statement)
                        .then(this.gotoTheGrid)
                        .catch(this.handleBackendError)
                        .finally(() => this.showLoading = false)
                    ;
                }
            });
        },
        close() {
            this.gotoTheGrid();
        },
        gotoTheGrid() {
            this.$router.push({name: 'administration-product-general-product-statements'});
        }
    },
    created() {
        if (this.id) {
            ProductApi
                .getGeneralProductStatement(this.id)
                .then(r => this.statement = r.data);
        }
        i18nApi.getLanguages().then(r => {
            if (!this.statement.translations) {
                this.statement.translations = {};
            }
            r.data.forEach(language => {
                if (this.statement.translations[language.code] === undefined) {
                    this.$set(this.statement.translations, language.code, {
                        organizationStatement: '',
                        productStatement: '',
                        exemptionMessage: ''
                    });
                }
            });
            this.languages = r.data
        }).finally(() => this.showLoading = false);
    }
}
</script>

<template>
    <Overlay :show="showLoading">
        <validation-observer ref="statement">
            <b-card :title="$t('Component(GeneralProductStatement):label')">
                <b-tabs>
                    <b-tab
                        v-for="language in languages"
                        :title="language.code.toUpperCase()"
                    >
                        <b-form-group
                            :label="$t('Component(Label):organization-statement')"
                            :label-for="'os' + language.code"
                        >
                            <validation-provider
                                #default="{ errors }"
                                :name="language.title + ' ' + $t('Component(Label):organization-statement')"
                                :rules="'required'"
                            >
                                <b-form-textarea
                                    :state="errors.length > 0 ? false:null"
                                    :id="'os' + language.code"
                                    v-model="statement.translations[language.code].organizationStatement"
                                    :placeholder="$t('Component(Label):organization-statement')"
                                />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <b-form-group
                            :label="$t('Component(Label):product-statement')"
                            :label-for="'ps' + language.code"
                        >
                            <validation-provider
                                #default="{ errors }"
                                :name="language.title + ' ' + $t('Component(Label):product-statement')"
                                :rules="'required'"
                            >
                                <b-form-textarea
                                    :state="errors.length > 0 ? false:null"
                                    :id="'ps' + language.code"
                                    v-model="statement.translations[language.code].productStatement"
                                    :placeholder="$t('Component(Label):product-statement')"
                                />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <b-form-group
                            :label="$t('Component(Label):exemption-message')"
                            :label-for="'em' + language.code"
                        >
                            <b-form-textarea
                                :id="'em' + language.code"
                                v-model="statement.translations[language.code].exemptionMessage"
                                :placeholder="$t('Component(Label):exemption-message')"
                            />
                        </b-form-group>
                    </b-tab>
                </b-tabs>
                <div class="text-right">
                    <Button
                        class="mr-1"
                        @click="save"
                    >
                        {{ $t('Component(Button):save') }}
                    </Button>

                    <Button
                        @click="close"
                    >
                        {{ $t('Component(Button):close') }}
                    </Button>
                </div>
            </b-card>
        </validation-observer>
    </Overlay>
</template>
